import Seo from "../components/Generic/Seo";
import ContactUs from "../components/Contactus/ContactUs";
import GoogleAnalytics from "../components/Generic/GoogleAnalytics";
import InViewFade from "../components/Generic/InViewFade";

const ContactPage = () => {
  const seoData = {
    title: "Contact WiSE — Women in Semiconductor Ecosystem",
    description:
      "Get in touch with WiSE (Women in Semiconductor Ecosystem). Whether you’re a student, professional or partner, we’d love to hear from you about mentorship, events, collaboration or media inquiries.",
    keywords:
      "contact WiSE, contact women in semiconductor, reach out WiSE, contact Women in Semiconductor Ecosystem, WiSE support contact, inquiry WiSE, semiconductor community contact",
    pathSlug: "contact",
  };

  return (
    <>
      <Seo data={seoData} />

      <GoogleAnalytics page={seoData.pathSlug} title={seoData.title} />

      <InViewFade>
        <ContactUs />
      </InViewFade>
    </>
  );
};

export default ContactPage;
